module.exports = __webpack_public_path__ + "static/media/giovana-roberta.208fad66.jpeg";